import { render, staticRenderFns } from "./budgets-rollover-line.vue?vue&type=template&id=282cd2a8"
import script from "./budgets-rollover-line.vue?vue&type=script&lang=js"
export * from "./budgets-rollover-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports